// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   CalendarDays,
//   Clock3,
//   Bell,
//   BellRing,
//   Radio,
//   Users,
//   Ban,
//   ArrowLeft,
//   Share2,
//   Play,
//   VideoOff,
// } from "lucide-react";
// import { Client } from "@stomp/stompjs";
// import SockJS from "sockjs-client";
// import "../css/UserLiveStream.css";
// import Layout from "./Layout/Layout";

// const BASE_URL = "http://localhost:8080";

// const iceServers = [
//   { urls: "stun:stun.l.google.com:19302" },
// ];

// const UserLiveStream = () => {
//   // const { id: routeId } = useParams();
//   // const id = routeId || "3";
//   const id = 4;

//   const navigate = useNavigate();

//   // Refs
//   const videoRef = useRef(null);
//   const playerRef = useRef(null);
//   const peerRef = useRef(null);
//   const stompRef = useRef(null);
//   const remoteStreamRef = useRef(null);

//   // Stream and UI state
//   const [stream, setStream] = useState(null);
//   const [error, setError] = useState("");
//   const [notify, setNotify] = useState(false);
//   const [timeLeft, setTimeLeft] = useState({});
//   const [currentTime, setCurrentTime] = useState(Date.now());
//   const [connectionStatus, setConnectionStatus] =
//     useState("Waiting for live stream...");
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [viewerCount, setViewerCount] = useState(0);
//   const [volume, setVolume] = useState(70);
//   const [adminCameraOff, setAdminCameraOff] = useState(false);

//   // STEP 1: Fetch stream details
//   useEffect(() => {
//     let active = true;

//     const fetchStream = async () => {
//       try {
//         const response = await axios.get(
//           `${BASE_URL}/api/streams/get/${id}`
//         );

//         if (active) {
//           setStream(response.data);
//           setError("");
//         }
//       } catch (err) {
//         console.error("Stream fetch error:", err);

//         if (active) {
//           setError("Unable to load live stream.");
//         }
//       }
//     };

//     if (id) {
//       fetchStream();
//     }

//     return () => {
//       active = false;
//     };
//   }, [id]);

//   // STEP 2: Update current time every second
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentTime(Date.now());
//     }, 1000);

//     return () => clearInterval(timer);
//   }, []);

//   // STEP 3: Calculate countdown
//   useEffect(() => {
//     if (!stream?.scheduledStart) {
//       setTimeLeft({});
//       return;
//     }

//     const difference =
//       new Date(stream.scheduledStart).getTime() - currentTime;

//     if (difference > 0) {
//       setTimeLeft({
//         days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//         hours: Math.floor(
//           (difference / (1000 * 60 * 60)) % 24
//         ),
//         minutes: Math.floor((difference / (1000 * 60)) % 60),
//         seconds: Math.floor((difference / 1000) % 60),
//       });
//     } else {
//       setTimeLeft({
//         days: 0,
//         hours: 0,
//         minutes: 0,
//         seconds: 0,
//       });
//     }
//   }, [currentTime, stream?.scheduledStart]);

//   const scheduledTimePassed =
//     stream?.scheduledStart &&
//     currentTime >= new Date(stream.scheduledStart).getTime();

//   const displayStatus =
//     stream?.status === "SCHEDULED" && scheduledTimePassed
//       ? "MISSED"
//       : stream?.status;

//   // STEP 4: Connect viewer to the admin using WebRTC
//   useEffect(() => {
//     if (!id || stream?.status !== "LIVE") {
//       setConnectionStatus(
//         stream?.status === "LIVE"
//           ? "Connecting..."
//           : "Waiting for live stream..."
//       );
//       return;
//     }

//     let disposed = false;
//     let client = null;
//     let peer = null;
//     let joined = false;
//     let remoteDescriptionSet = false;

//     const viewerId = crypto.randomUUID();
//     const pendingIceCandidates = [];
//     const remoteStream = new MediaStream();

//     remoteStreamRef.current = remoteStream;

//     const userId = Number(sessionStorage.getItem("userId"));

//     const sendSignal = (type, payload = {}) => {
//       if (!client?.connected || disposed) return;

//       client.publish({
//         destination: `/app/webrtc/${id}/signal`,
//         body: JSON.stringify({
//           type,
//           from: viewerId,
//           target: "admin",
//           ...payload,
//         }),
//       });
//     };

//     const handleSignal = async (message) => {
//       if (!peer || disposed) return;

//       if (message.type === "offer") {
//         await peer.setRemoteDescription(
//           new RTCSessionDescription(message.sdp)
//         );

//         remoteDescriptionSet = true;

//         for (const candidate of pendingIceCandidates.splice(0)) {
//           await peer.addIceCandidate(
//             new RTCIceCandidate(candidate)
//           );
//         }

//         const answer = await peer.createAnswer();
//         await peer.setLocalDescription(answer);

//         sendSignal("answer", {
//           sdp: peer.localDescription,
//         });

//         setConnectionStatus("Connecting...");
//       }

//       if (message.type === "ice" && message.candidate) {
//         if (remoteDescriptionSet) {
//           await peer.addIceCandidate(
//             new RTCIceCandidate(message.candidate)
//           );
//         } else {
//           pendingIceCandidates.push(message.candidate);
//         }
//       }
//     };

//     const connect = async () => {
//       try {
//         setConnectionStatus("Connecting...");

//         peer = new RTCPeerConnection({ iceServers });
//         peerRef.current = peer;

//         peer.addTransceiver("video", {
//           direction: "recvonly",
//         });

//         peer.addTransceiver("audio", {
//           direction: "recvonly",
//         });

//         // peer.ontrack = (event) => {
//         //   if (disposed) return;

//         //   if (
//         //     !remoteStream
//         //       .getTracks()
//         //       .some((track) => track.id === event.track.id)
//         //   ) {
//         //     remoteStream.addTrack(event.track);
//         //   }

//         //   if (videoRef.current) {
//         //     videoRef.current.srcObject = remoteStream;
//         //     videoRef.current.volume = volume / 100;

//         //     videoRef.current.play().catch((err) => {
//         //       console.log("Autoplay blocked; click Play:", err);
//         //     });
//         //   }
//         // };

        
// peer.ontrack = (event) => {
//   if (disposed) return;

//   const track = event.track;

//   if (
//     !remoteStream
//       .getTracks()
//       .some((existingTrack) => existingTrack.id === track.id)
//   ) {
//     remoteStream.addTrack(track);
//   }

//   // if (track.kind === "video") {
//   //   track.onmute = () => {
//   //     if (videoRef.current) {
//   //       videoRef.current.pause();
//   //       videoRef.current.srcObject = null;
//   //     }

//   //     setIsPlaying(false);
//   //     setConnectionStatus("Admin camera is off");
//   //   };

//   //   track.onunmute = () => {
//   //     if (videoRef.current) {
//   //       videoRef.current.srcObject = remoteStream;
//   //       videoRef.current.play().catch(console.error);
//   //     }

//   //     setConnectionStatus("Connected");
//   //   };

//   //   track.onended = () => {
//   //     if (videoRef.current) {
//   //       videoRef.current.pause();
//   //       videoRef.current.srcObject = null;
//   //     }

//   //     setIsPlaying(false);
//   //     setConnectionStatus("Admin camera is off");
//   //   };
//   // }

//   if (track.kind === "video") {
//   track.onmute = () => {
//     setAdminCameraOff(true);

//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.srcObject = null;
//     }

//     setIsPlaying(false);
//     setConnectionStatus("Admin camera is off");
//   };

//   track.onunmute = () => {
//     setAdminCameraOff(false);

//     if (videoRef.current) {
//       videoRef.current.srcObject = remoteStream;
//       videoRef.current.play().catch(console.error);
//     }

//     setConnectionStatus("Connected");
//   };

//   track.onended = () => {
//     setAdminCameraOff(true);

//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.srcObject = null;
//     }

//     setIsPlaying(false);
//     setConnectionStatus("Admin camera is off");
//   };
// }

//   if (videoRef.current) {
//     videoRef.current.srcObject = remoteStream;
//     videoRef.current.volume = volume / 100;

//     videoRef.current.play().catch((err) => {
//       console.log("Autoplay blocked:", err);
//     });
//   }
// };


//         peer.onicecandidate = (event) => {
//           if (event.candidate) {
//             sendSignal("ice", {
//               candidate: event.candidate.toJSON(),
//             });
//           }
//         };

//         peer.onconnectionstatechange = () => {
//           if (disposed || !peer) return;

//           switch (peer.connectionState) {
//             case "connected":
//               setConnectionStatus("Connected");
//               break;
//             case "connecting":
//               setConnectionStatus("Connecting...");
//               break;
//             case "failed":
//               setConnectionStatus("Connection failed");
//               break;
//             case "disconnected":
//               setConnectionStatus("Disconnected");
//               break;
//             case "closed":
//               setConnectionStatus("Connection closed");
//               break;
//             default:
//               break;
//           }
//         };

//         client = new Client({
//           webSocketFactory: () =>
//             new SockJS(`${BASE_URL}/ws-livestream`),
//           reconnectDelay: 5000,

//           onConnect: async () => {
//             if (disposed) return;

//             client.subscribe(
//               `/topic/webrtc/${id}/${viewerId}`,
//               (frame) => {
//                 try {
//                   const message = JSON.parse(frame.body);
//                   handleSignal(message).catch((err) => {
//                     console.error("Signaling error:", err);
//                     if (!disposed) {
//                       setConnectionStatus("Signaling error");
//                     }
//                   });
//                 } catch (err) {
//                   console.error("Invalid signaling message:", err);
//                 }
//               }
//             );

//             client.subscribe(
//               `/topic/stream/${id}/viewer-count`,
//               (frame) => {
//                 try {
//                   const data = JSON.parse(frame.body);
//                   if (!disposed) {
//                     setViewerCount(Number(data.count || 0));
//                   }
//                 } catch (err) {
//                   console.error("Viewer count error:", err);
//                 }
//               }
//             );

//             client.subscribe(
//               `/topic/stream/${id}/status`,
//               (frame) => {
//                 try {
//                   const event = JSON.parse(frame.body);

//                   if (event.status === "ENDED" && !disposed) {
//                     setConnectionStatus("Stream ended");
//                     peer?.close();
//                   }
//                 } catch (err) {
//                   console.error("Stream status error:", err);
//                 }
//               }
//             );

//             try {
//               if (!Number.isSafeInteger(userId) || userId <= 0) {
//                 throw new Error(
//                   "Valid logged-in userId is required in sessionStorage."
//                 );
//               }

//               await axios.post(
//                 `${BASE_URL}/api/streams/${id}/viewers/join`,
//                 {
//                   userId,
//                   peerId: viewerId,
//                 }
//               );

//               if (disposed) return;

//               joined = true;
//               sendSignal("join");
//               setConnectionStatus("Waiting for admin video...");
//             } catch (err) {
//               if (!disposed) {
//                 console.error("Viewer join error:", err);
//                 setError(
//                   err.response?.data?.message ||
//                     err.message ||
//                     "Unable to join the live stream."
//                 );
//               }
//             }
//           },

//           onStompError: (frame) => {
//             if (!disposed) {
//               console.error("STOMP error:", frame.body);
//               setConnectionStatus("WebSocket error");
//             }
//           },

//           onWebSocketError: (err) => {
//             if (!disposed) {
//               console.error("WebSocket error:", err);
//               setConnectionStatus("WebSocket disconnected");
//             }
//           },
//         });

//         stompRef.current = client;
//         client.activate();
//       } catch (err) {
//         if (!disposed) {
//           console.error("WebRTC connection error:", err);
//           setConnectionStatus("Connection failed");
//         }
//       }
//     };

//     connect();

//     return () => {
//       disposed = true;

//       if (client?.connected) {
//         client.publish({
//           destination: `/app/webrtc/${id}/signal`,
//           body: JSON.stringify({
//             type: "leave",
//             from: viewerId,
//             target: "admin",
//           }),
//         });
//       }

//       if (peer) {
//         peer.ontrack = null;
//         peer.onicecandidate = null;
//         peer.onconnectionstatechange = null;
//         peer.close();
//       }

//       if (client) {
//         client.deactivate();
//       }

//       if (videoRef.current) {
//         videoRef.current.srcObject = null;
//       }

//       if (peerRef.current === peer) {
//         peerRef.current = null;
//       }

//       if (stompRef.current === client) {
//         stompRef.current = null;
//       }

//       remoteStream.getTracks().forEach((track) => track.stop());
//       remoteStreamRef.current = null;

//       if (joined) {
//         axios
//           .post(`${BASE_URL}/api/streams/${id}/viewers/leave`, {
//             peerId: viewerId,
//           })
//           .catch((err) => {
//             console.error("Viewer leave error:", err);
//           });
//       }
//     };
//   }, [id, stream?.status, volume]);

//   // STEP 5: Formatting helpers
//   const formatDate = (date) => {
//     if (!date) return "Not scheduled";

//     const parsedDate = new Date(date);
//     if (Number.isNaN(parsedDate.getTime())) {
//       return "Invalid date";
//     }

//     return parsedDate.toLocaleString("en-IN", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const formatNumber = (num) =>
//     Number(num || 0).toLocaleString("en-IN");

//   // STEP 6: Countdown renderer — no hooks inside this function
//   const renderCountdown = () => {
//     const items = [
//       { label: "Days", value: timeLeft.days },
//       { label: "Hours", value: timeLeft.hours },
//       { label: "Minutes", value: timeLeft.minutes },
//       { label: "Seconds", value: timeLeft.seconds },
//     ];

//     return (
//       <div className="live-countdown">
//         {items.map((item) => (
//           <div className="countdown-box" key={item.label}>
//             <strong>
//               {String(item.value ?? 0).padStart(2, "0")}
//             </strong>
//             <span>{item.label}</span>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   const handleNotify = () => {
//     setNotify((previous) => !previous);
//   };

//   const handleShare = async () => {
//     try {
//       if (navigator.share) {
//         await navigator.share({
//           title: stream?.title || "Live Stream",
//           url: window.location.href,
//         });
//       } else if (navigator.clipboard) {
//         await navigator.clipboard.writeText(window.location.href);
//         alert("Live stream link copied!");
//       }
//     } catch (err) {
//       if (err.name !== "AbortError") {
//         console.error("Share failed:", err);
//       }
//     }
//   };

//   const togglePlay = async () => {
//     const video = videoRef.current;
//     if (!video) return;

//     try {
//       if (video.paused) {
//         await video.play();
//       } else {
//         video.pause();
//       }
//     } catch (err) {
//       console.error("Playback error:", err);
//     }
//   };

//   const handleVolume = (event) => {
//     const value = Number(event.target.value);
//     setVolume(value);

//     if (videoRef.current) {
//       videoRef.current.volume = value / 100;
//     }
//   };

//   const handleFullscreen = async () => {
//     const player = playerRef.current;
//     if (!player) return;

//     try {
//       if (document.fullscreenElement) {
//         await document.exitFullscreen();
//       } else {
//         await player.requestFullscreen();
//       }
//     } catch (err) {
//       console.error("Fullscreen error:", err);
//     }
//   };

//   const handlePictureInPicture = async () => {
//     const video = videoRef.current;

//     if (!video || !document.pictureInPictureEnabled) return;

//     try {
//       if (document.pictureInPictureElement) {
//         await document.exitPictureInPicture();
//       } else {
//         await video.requestPictureInPicture();
//       }
//     } catch (err) {
//       console.error("Picture-in-picture error:", err);
//     }
//   };

//   const renderLiveContent = () => {
//     switch (displayStatus) {
//       case "SCHEDULED":
//         return (
//           <div className="live-state-content">
//             <div className="live-state-icon">
//               <CalendarDays size={58} strokeWidth={1.5} />
//             </div>

//             <h2>Upcoming Live Event</h2>
//             <p>Scheduled for {formatDate(stream?.scheduledStart)}</p>

//             {renderCountdown()}

//             <button
//               className={`live-primary-btn ${
//                 notify ? "notification-active" : ""
//               }`}
//               onClick={handleNotify}
//             >
//               {notify ? <BellRing size={19} /> : <Bell size={19} />}
//               {notify ? "Reminder Enabled" : "Notify Me"}
//             </button>

//             <span className="live-helper-text">
//               {notify
//                 ? "Reminder preference saved on this page."
//                 : "Get notified when the live stream starts."}
//             </span>
//           </div>
//         );

//       // case "LIVE":
//       //   return (
//       //     <div className="live-video-wrapper" ref={playerRef}>
//       //       <div className="live-video-badges">
//       //         <span className="live-red-badge">
//       //           <Radio size={15} />
//       //           LIVE
//       //         </span>

//       //         <span className="live-viewer-badge">
//       //           <Users size={15} />
//       //           {formatNumber(viewerCount)}
//       //         </span>
//       //       </div>

//       //       <video
//       //         ref={videoRef}
//       //         className="live-video-player"
//       //         autoPlay
//       //         playsInline
//       //         controls
//       //         onPlay={() => setIsPlaying(true)}
//       //         onPause={() => setIsPlaying(false)}
//       //       />

//       //       {!isPlaying && (
//       //         <div className="live-video-placeholder">
//       //           <Play size={65} />
//       //           <h2>Live Stream</h2>
//       //           <p>{connectionStatus}</p>
//       //           <button
//       //             className="live-primary-btn"
//       //             onClick={togglePlay}
//       //           >
//       //             Play
//       //           </button>
//       //         </div>
//       //       )}

//       //       <div className="live-custom-controls">
//       //         <button onClick={togglePlay}>
//       //           {isPlaying ? "Pause" : "Play"}
//       //         </button>

//       //         <label>
//       //           Volume
//       //           <input
//       //             type="range"
//       //             min="0"
//       //             max="100"
//       //             value={volume}
//       //             onChange={handleVolume}
//       //           />
//       //         </label>

//       //         <button onClick={handleFullscreen}>
//       //           Fullscreen
//       //         </button>

//       //         {document.pictureInPictureEnabled && (
//       //           <button onClick={handlePictureInPicture}>
//       //             Picture in Picture
//       //           </button>
//       //         )}
//       //       </div>
//       //     </div>
//       //   );


//       case "LIVE":
//   return (
//     <div className="live-video-wrapper" ref={playerRef}>
//       <div className="live-video-badges">
//         <span className="live-red-badge">
//           <Radio size={15} />
//           LIVE
//         </span>

//         <span className="live-viewer-badge">
//           <Users size={15} />
//           {formatNumber(viewerCount)}
//         </span>
//       </div>

//       <video
//         ref={videoRef}
//         className="live-video-player"
//         autoPlay
//         playsInline
//         controls
//         onPlay={() => setIsPlaying(true)}
//         onPause={() => setIsPlaying(false)}
//       />

//       {/* ADD THIS BLOCK immediately after the video */}
//       {adminCameraOff && (
//         <div className="camera-off-message">
//           <VideoOff size={48} />
//           <h3>Admin camera is off</h3>
//           <p>Please wait for the host to turn the camera back on.</p>
//         </div>
//       )}

//       {!isPlaying && !adminCameraOff && (
//         <div className="live-video-placeholder">
//           <Play size={65} />
//           <h2>Live Stream</h2>
//           <p>{connectionStatus}</p>
//           <button
//             className="live-primary-btn"
//             onClick={togglePlay}
//           >
//             Play
//           </button>
//         </div>
//       )}

//       <div className="live-custom-controls">
//         <button onClick={togglePlay}>
//           {isPlaying ? "Pause" : "Play"}
//         </button>

//         <label>
//           Volume
//           <input
//             type="range"
//             min="0"
//             max="100"
//             value={volume}
//             onChange={handleVolume}
//           />
//         </label>

//         <button onClick={handleFullscreen}>
//           Fullscreen
//         </button>

//         {document.pictureInPictureEnabled && (
//           <button onClick={handlePictureInPicture}>
//             Picture in Picture
//           </button>
//         )}
//       </div>
//     </div>
//   );

//       case "MISSED":
//         return (
//           <div className="live-state-content">
//             <div className="live-state-icon">
//               <Clock3 size={65} strokeWidth={1.5} />
//             </div>

//             <h2>The live stream hasn't started yet</h2>
//             <p>
//               The host hasn't started streaming. Please check back soon.
//             </p>

//             <div className="live-schedule-info">
//               <CalendarDays size={25} />
//               <div>
//                 <span>Originally scheduled for</span>
//                 <strong>{formatDate(stream?.scheduledStart)}</strong>
//               </div>
//             </div>

//             <div className="live-waiting-indicator">
//               <span className="waiting-dot" />
//               Waiting for host
//             </div>
//           </div>
//         );

//       case "CANCELLED":
//         return (
//           <div className="live-state-content">
//             <div className="live-cancel-icon">
//               <Ban size={70} strokeWidth={1.5} />
//             </div>

//             <h2>This live stream has been cancelled</h2>
//             <p>The host has cancelled this live event.</p>

//             <button
//               className="live-primary-btn"
//               onClick={() => navigate("/live")}
//             >
//               Browse Other Live Streams
//             </button>
//           </div>
//         );

//       case "ENDED":
//         return (
//           <div className="live-state-content">
//             <VideoOff size={65} />
//             <h2>Live Stream Ended</h2>
//             <p>
//               This live session has finished. Thank you for watching!
//             </p>

//             <button
//               className="live-primary-btn"
//               onClick={() => navigate("/live")}
//             >
//               Explore More Streams
//             </button>
//           </div>
//         );

//       default:
//         return (
//           <div className="live-state-content">
//             <h2>Live stream unavailable</h2>
//           </div>
//         );
//     }
//   };

//   // Conditional returns are after all hooks
//   if (error) {
//     return (
//       <Layout>
//         <div className="user-live-page">
//           <p>{error}</p>
//           <button onClick={() => navigate("/live-streams")}>
//             Back to live streams
//           </button>
//         </div>
//       </Layout>
//     );
//   }

//   if (!stream) {
//     return (
//       <Layout>
//         <div className="user-live-page">
//           <p>Loading live stream...</p>
//         </div>
//       </Layout>
//     );
//   }

//   return (
//     <Layout>
//       <div className="user-live-page">
//         <div className="user-live-container">
//           <div className="user-live-header">
//             <button
//               className="live-icon-btn"
//               onClick={() => navigate(-1)}
//               aria-label="Go back"
//             >
//               <ArrowLeft size={23} />
//             </button>

//             <h3>Live Streaming</h3>

//             <button
//               className="live-icon-btn"
//               onClick={handleShare}
//               aria-label="Share live stream"
//             >
//               <Share2 size={23} />
//             </button>
//           </div>

//           <div className="live-player-card">
//             {renderLiveContent()}
//           </div>

//           {/* <div className="live-details-card">
//             <div className="live-details-header">
//               <h2>{stream.title || "Live Stream"}</h2>

//               <span
//                 className={`live-status-label status-${(
//                   displayStatus || "unknown"
//                 ).toLowerCase()}`}
//               >
//                 {displayStatus === "MISSED"
//                   ? "NOT STARTED"
//                   : displayStatus || "UNKNOWN"}
//               </span>
//             </div>

//             <p>{stream.description || "No description available."}</p>

//             <div className="live-host-info">
//               <div className="live-host-avatar">A</div>
//               <div>
//                 <strong>Admin</strong>
//                 <span>Live Stream Host</span>
//               </div>
//             </div>

//             <div className="live-event-details">
//               <CalendarDays size={18} />
//               <span>{formatDate(stream.scheduledStart)}</span>
//             </div>

//             {displayStatus === "LIVE" && (
//               <p className="live-connection-status">
//                 Connection: {connectionStatus}
//               </p>
//             )}
//           </div> */}
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default UserLiveStream;


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  CalendarDays,
  Clock3,
  Bell,
  BellRing,
  Radio,
  Users,
  Ban,
  ArrowLeft,
  Share2,
  Play,
  VideoOff,
  LogOut,
} from "lucide-react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import "../css/UserLiveStream.css";
import Layout from "./Layout/Layout";
import API_URL from "../Config";

const BASE_URL = API_URL;

const iceServers = [
  { urls: "stun:stun.l.google.com:19302" },
];

const UserLiveStream = () => {
  // Change this to the route ID when you want dynamic stream IDs.
  // Example route: /weblive/:id
  const { id } = useParams();
  // const id = 6;

  const navigate = useNavigate();

  // Refs
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const peerRef = useRef(null);
  const stompRef = useRef(null);
  const remoteStreamRef = useRef(null);

  // State
  const [stream, setStream] = useState(null);
  const [error, setError] = useState("");
  const [notify, setNotify] = useState(false);
  const [timeLeft, setTimeLeft] = useState({});
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [connectionStatus, setConnectionStatus] = useState(
    "Waiting for live stream..."
  );
  const [isPlaying, setIsPlaying] = useState(false);
  const [viewerCount, setViewerCount] = useState(0);
  const [volume, setVolume] = useState(70);
  const [adminCameraOff, setAdminCameraOff] = useState(false);

  // STEP 1: Fetch stream details
  useEffect(() => {
    let active = true;

    const fetchStream = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/streams/get/${id}`
        );

        if (active) {
          setStream(response.data);
          setError("");
        }
      } catch (err) {
        console.error("Stream fetch error:", err);

        if (active) {
          setError("Unable to load live stream.");
        }
      }
    };

    if (id) {
      fetchStream();
    }

    return () => {
      active = false;
    };
  }, [id]);

  // STEP 2: Update current time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // STEP 3: Calculate countdown
  useEffect(() => {
    if (!stream?.scheduledStart) {
      setTimeLeft({});
      return;
    }

    const difference =
      new Date(stream.scheduledStart).getTime() - currentTime;

    if (difference > 0) {
      setTimeLeft({
        days: Math.floor(
          difference / (1000 * 60 * 60 * 24)
        ),
        hours: Math.floor(
          (difference / (1000 * 60 * 60)) % 24
        ),
        minutes: Math.floor(
          (difference / (1000 * 60)) % 60
        ),
        seconds: Math.floor(
          (difference / 1000) % 60
        ),
      });
    } else {
      setTimeLeft({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
    }
  }, [currentTime, stream?.scheduledStart]);

  const scheduledTimePassed =
    stream?.scheduledStart &&
    currentTime >= new Date(stream.scheduledStart).getTime();

  const displayStatus =
    stream?.status === "SCHEDULED" && scheduledTimePassed
      ? "MISSED"
      : stream?.status;

  // STEP 4: Connect viewer to admin using WebRTC
  useEffect(() => {
    if (!id || stream?.status !== "LIVE") {
      setConnectionStatus(
        stream?.status === "LIVE"
          ? "Connecting..."
          : "Waiting for live stream..."
      );
      return;
    }

    let disposed = false;
    let client = null;
    let peer = null;
    let joined = false;
    let leaveRequested = false;
    let remoteDescriptionSet = false;

    const viewerId = crypto.randomUUID();
    const pendingIceCandidates = [];
    const remoteStream = new MediaStream();

    remoteStreamRef.current = remoteStream;

    const userId = Number(
      sessionStorage.getItem("userId")
    );

    // Call the backend leave endpoint once for this viewer session.
    const leaveViewer = () => {
      if (!joined || leaveRequested) return;

      leaveRequested = true;

      axios
        .post(
          `${BASE_URL}/api/streams/${id}/viewers/leave`,
          {
            peerId: viewerId,
          }
        )
        .catch((err) => {
          console.error("Viewer leave error:", err);
        });
    };

    // Best-effort notification when the browser page is closed
    // or navigated away from.
    const handlePageHide = () => {
      if (!joined || leaveRequested) return;

      const payload = new Blob(
        [JSON.stringify({ peerId: viewerId })],
        { type: "application/json" }
      );

      if (navigator.sendBeacon) {
        const sent = navigator.sendBeacon(
          `${BASE_URL}/api/streams/${id}/viewers/leave`,
          payload
        );

        if (sent) {
          leaveRequested = true;
        }
      }
    };

    window.addEventListener("pagehide", handlePageHide);

    // Send signaling messages to the admin.
    const sendSignal = (type, payload = {}) => {
      if (!client?.connected || disposed) return;

      client.publish({
        destination: `/app/webrtc/${id}/signal`,
        body: JSON.stringify({
          type,
          from: viewerId,
          target: "admin",
          ...payload,
        }),
      });
    };

    // Handle offers and ICE candidates from the admin.
    const handleSignal = async (message) => {
      if (!peer || disposed) return;

      if (message.type === "offer") {
        await peer.setRemoteDescription(
          new RTCSessionDescription(message.sdp)
        );

        remoteDescriptionSet = true;

        for (const candidate of pendingIceCandidates.splice(0)) {
          await peer.addIceCandidate(
            new RTCIceCandidate(candidate)
          );
        }

        const answer = await peer.createAnswer();
        await peer.setLocalDescription(answer);

        sendSignal("answer", {
          sdp: peer.localDescription,
        });

        setConnectionStatus("Connecting...");
      }

      if (message.type === "ice" && message.candidate) {
        if (remoteDescriptionSet) {
          await peer.addIceCandidate(
            new RTCIceCandidate(message.candidate)
          );
        } else {
          pendingIceCandidates.push(message.candidate);
        }
      }
    };

    const connect = async () => {
      try {
        setConnectionStatus("Connecting...");

        peer = new RTCPeerConnection({ iceServers });
        peerRef.current = peer;

        peer.addTransceiver("video", {
          direction: "recvonly",
        });

        peer.addTransceiver("audio", {
          direction: "recvonly",
        });

        // Receive the admin's audio and video.
        peer.ontrack = (event) => {
          if (disposed) return;

          const track = event.track;

          if (
            !remoteStream
              .getTracks()
              .some(
                (existingTrack) =>
                  existingTrack.id === track.id
              )
          ) {
            remoteStream.addTrack(track);
          }

          if (track.kind === "video") {
            track.onmute = () => {
              if (disposed) return;

              setAdminCameraOff(true);
              setIsPlaying(false);
              setConnectionStatus("Admin camera is off");

              if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.srcObject = null;
              }
            };

            track.onunmute = () => {
              if (disposed) return;

              setAdminCameraOff(false);
              setConnectionStatus("Connected");

              if (videoRef.current) {
                videoRef.current.srcObject = remoteStream;
                videoRef.current.volume = volume / 100;

                videoRef.current.play().catch((err) => {
                  console.log(
                    "Autoplay blocked. Click Play:",
                    err
                  );
                });
              }
            };

            track.onended = () => {
              if (disposed) return;

              setAdminCameraOff(true);
              setIsPlaying(false);
              setConnectionStatus("Admin camera is off");

              if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.srcObject = null;
              }
            };
          }

          if (videoRef.current) {
            videoRef.current.srcObject = remoteStream;
            videoRef.current.volume = volume / 100;

            videoRef.current.play().catch((err) => {
              console.log("Autoplay blocked:", err);
            });
          }
        };

        // Send local ICE candidates to the admin.
        peer.onicecandidate = (event) => {
          if (event.candidate) {
            sendSignal("ice", {
              candidate: event.candidate.toJSON(),
            });
          }
        };

        // Monitor WebRTC connection state.
        peer.onconnectionstatechange = () => {
          if (disposed || !peer) return;

          switch (peer.connectionState) {
            case "connected":
              setConnectionStatus("Connected");
              break;

            case "connecting":
              setConnectionStatus("Connecting...");
              break;

            case "failed":
              setConnectionStatus("Connection failed");
              break;

            case "disconnected":
              setConnectionStatus("Disconnected");
              break;

            case "closed":
              setConnectionStatus("Connection closed");
              break;

            default:
              break;
          }
        };

        // Connect STOMP over SockJS.
        client = new Client({
          webSocketFactory: () =>
            new SockJS(`${BASE_URL}/ws-livestream`),

          reconnectDelay: 5000,

          onConnect: async () => {
            if (disposed) return;

            // Receive WebRTC signaling messages for this viewer.
            client.subscribe(
              `/topic/webrtc/${id}/${viewerId}`,
              (frame) => {
                try {
                  const message = JSON.parse(frame.body);

                  handleSignal(message).catch((err) => {
                    console.error("Signaling error:", err);

                    if (!disposed) {
                      setConnectionStatus("Signaling error");
                    }
                  });
                } catch (err) {
                  console.error(
                    "Invalid signaling message:",
                    err
                  );
                }
              }
            );

            // Receive viewer-count updates.
            client.subscribe(
              `/topic/stream/${id}/viewer-count`,
              (frame) => {
                try {
                  const data = JSON.parse(frame.body);

                  if (!disposed) {
                    setViewerCount(Number(data.count || 0));
                  }
                } catch (err) {
                  console.error("Viewer count error:", err);
                }
              }
            );

            // Receive stream-status updates.
            client.subscribe(
              `/topic/stream/${id}/status`,
              (frame) => {
                try {
                  const event = JSON.parse(frame.body);

                  if (
                    event.status === "ENDED" &&
                    !disposed
                  ) {
                    setConnectionStatus("Stream ended");
                    peer?.close();
                  }
                } catch (err) {
                  console.error("Stream status error:", err);
                }
              }
            );

            try {
              if (
                !Number.isSafeInteger(userId) ||
                userId <= 0
              ) {
                throw new Error(
                  "Valid logged-in userId is required in sessionStorage."
                );
              }

              // Register this viewer session in the backend.
              await axios.post(
                `${BASE_URL}/api/streams/${id}/viewers/join`,
                {
                  userId,
                  peerId: viewerId,
                }
              );

              joined = true;

              // If the viewer left while the join request was
              // in progress, remove the newly created session.
              if (disposed) {
                leaveViewer();
                return;
              }

              sendSignal("join");

              setConnectionStatus(
                "Waiting for admin video..."
              );
            } catch (err) {
              if (!disposed) {
                console.error("Viewer join error:", err);

                setError(
                  err.response?.data?.message ||
                    err.message ||
                    "Unable to join the live stream."
                );
              }
            }
          },

          onStompError: (frame) => {
            if (!disposed) {
              console.error("STOMP error:", frame.body);
              setConnectionStatus("WebSocket error");
            }
          },

          onWebSocketError: (err) => {
            if (!disposed) {
              console.error("WebSocket error:", err);
              setConnectionStatus("WebSocket disconnected");
            }
          },
        });

        stompRef.current = client;
        client.activate();
      } catch (err) {
        if (!disposed) {
          console.error("WebRTC connection error:", err);
          setConnectionStatus("Connection failed");
        }
      }
    };

    connect();

    // Cleanup runs when the viewer leaves this React page.
    return () => {
      disposed = true;

      window.removeEventListener(
        "pagehide",
        handlePageHide
      );

      // Notify the admin that this viewer is leaving.
      if (client?.connected) {
        client.publish({
          destination: `/app/webrtc/${id}/signal`,
          body: JSON.stringify({
            type: "leave",
            from: viewerId,
            target: "admin",
          }),
        });
      }

      // Close WebRTC.
      if (peer) {
        peer.ontrack = null;
        peer.onicecandidate = null;
        peer.onconnectionstatechange = null;
        peer.close();
      }

      // Disconnect STOMP.
      if (client) {
        client.deactivate();
      }

      // Clear the video.
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }

      if (peerRef.current === peer) {
        peerRef.current = null;
      }

      if (stompRef.current === client) {
        stompRef.current = null;
      }

      remoteStream.getTracks().forEach((track) => {
        track.stop();
      });

      remoteStreamRef.current = null;

      // Remove the viewer from the backend.
      leaveViewer();
    };
  }, [id, stream?.status]);

  // STEP 5: Formatting helpers
  const formatDate = (date) => {
    if (!date) return "Not scheduled";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "Invalid date";
    }

    return parsedDate.toLocaleString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatNumber = (num) =>
    Number(num || 0).toLocaleString("en-IN");

  // STEP 6: Countdown renderer
  const renderCountdown = () => {
    const items = [
      { label: "Days", value: timeLeft.days },
      { label: "Hours", value: timeLeft.hours },
      { label: "Minutes", value: timeLeft.minutes },
      { label: "Seconds", value: timeLeft.seconds },
    ];

    return (
      <div className="live-countdown">
        {items.map((item) => (
          <div className="countdown-box" key={item.label}>
            <strong>
              {String(item.value ?? 0).padStart(2, "0")}
            </strong>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const handleNotify = () => {
    setNotify((previous) => !previous);
  };

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: stream?.title || "Live Stream",
          url: window.location.href,
        });
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(
          window.location.href
        );

        alert("Live stream link copied!");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("Share failed:", err);
      }
    }
  };

  // Leave the stream and navigate to the stream list.
  // The WebRTC effect cleanup calls the backend leave endpoint.
  const handleLeaveStream = () => {
    navigate("/live-streams", { replace: true });
  };

  const togglePlay = async () => {
    const video = videoRef.current;

    if (!video) return;

    try {
      if (video.paused) {
        await video.play();
      } else {
        video.pause();
      }
    } catch (err) {
      console.error("Playback error:", err);
    }
  };

  const handleVolume = (event) => {
    const value = Number(event.target.value);

    setVolume(value);

    if (videoRef.current) {
      videoRef.current.volume = value / 100;
    }
  };

  const handleFullscreen = async () => {
    const player = playerRef.current;

    if (!player) return;

    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await player.requestFullscreen();
      }
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };

  const handlePictureInPicture = async () => {
    const video = videoRef.current;

    if (!video || !document.pictureInPictureEnabled) {
      return;
    }

    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else {
        await video.requestPictureInPicture();
      }
    } catch (err) {
      console.error("Picture-in-picture error:", err);
    }
  };

  // STEP 7: Render content based on stream status
  const renderLiveContent = () => {
    switch (displayStatus) {
      case "SCHEDULED":
        return (
          <div className="live-state-content">
            <div className="live-state-icon">
              <CalendarDays size={58} strokeWidth={1.5} />
            </div>

            <h2>Upcoming Live Event</h2>

            <p>
              Scheduled for {formatDate(stream?.scheduledStart)}
            </p>

            {renderCountdown()}

            <button
              className={`live-primary-btn ${
                notify ? "notification-active" : ""
              }`}
              onClick={handleNotify}
            >
              {notify ? (
                <BellRing size={19} />
              ) : (
                <Bell size={19} />
              )}

              {notify ? "Reminder Enabled" : "Notify Me"}
            </button>

            <span className="live-helper-text">
              {notify
                ? "Reminder preference saved on this page."
                : "Get notified when the live stream starts."}
            </span>
          </div>
        );

      case "LIVE":
        return (
          <div
            className="live-video-wrapper"
            ref={playerRef}
          >
            <div className="live-video-badges">
              <span className="live-red-badge">
                <Radio size={15} />
                LIVE
              </span>

              <span className="live-viewer-badge">
                <Users size={15} />
                {formatNumber(viewerCount)}
              </span>
            </div>

            <video
              ref={videoRef}
              className="live-video-player"
              autoPlay
              playsInline
              controls
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />

            {adminCameraOff && (
              <div className="camera-off-message">
                <VideoOff size={48} />
                <h3>Admin camera is off</h3>
                <p>
                  Please wait for the host to turn the camera
                  back on.
                </p>
              </div>
            )}

            {!isPlaying && !adminCameraOff && (
              <div className="live-video-placeholder">
                <Play size={65} />
                <h2>Live Stream</h2>
                <p>{connectionStatus}</p>

                <button
                  className="live-primary-btn"
                  onClick={togglePlay}
                >
                  Play
                </button>
              </div>
            )}

            {/* <div className="live-custom-controls">
              <button onClick={togglePlay}>
                {isPlaying ? "Pause" : "Play"}
              </button>

              <label>
                Volume
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={volume}
                  onChange={handleVolume}
                />
              </label>

              <button onClick={handleFullscreen}>
                Fullscreen
              </button>

              {document.pictureInPictureEnabled && (
                <button onClick={handlePictureInPicture}>
                  Picture in Picture
                </button>
              )}
            </div> */}
          </div>
        );

      case "MISSED":
        return (
          <div className="live-state-content">
            <div className="live-state-icon">
              <Clock3 size={65} strokeWidth={1.5} />
            </div>

            <h2>The live stream hasn't started yet</h2>

            <p>
              The host hasn't started streaming. Please check
              back soon.
            </p>

            <div className="live-schedule-info">
              <CalendarDays size={25} />

              <div>
                <span>Originally scheduled for</span>
                <strong>
                  {formatDate(stream?.scheduledStart)}
                </strong>
              </div>
            </div>

            <div className="live-waiting-indicator">
              <span className="waiting-dot" />
              Waiting for host
            </div>
          </div>
        );

      case "CANCELLED":
        return (
          <div className="live-state-content">
            <div className="live-cancel-icon">
              <Ban size={70} strokeWidth={1.5} />
            </div>

            <h2>This live stream has been cancelled</h2>
            <p>The host has cancelled this live event.</p>

            <button
              className="live-primary-btn"
              onClick={() => navigate("/live")}
            >
              Browse Other Live Streams
            </button>
          </div>
        );

      case "ENDED":
        return (
          <div className="live-state-content">
            <VideoOff size={65} />

            <h2>Live Stream Ended</h2>

            <p>
              This live session has finished. Thank you for
              watching!
            </p>

            <button
              className="live-primary-btn"
              onClick={() => navigate("/live")}
            >
              Explore More Streams
            </button>
          </div>
        );

      default:
        return (
          <div className="live-state-content">
            <h2>Live stream unavailable</h2>
          </div>
        );
    }
  };

  // STEP 8: Loading and error states
  if (error) {
    return (
      <Layout>
        <div className="user-live-page">
          <p>{error}</p>

          <button
            onClick={() => navigate("/live-streams")}
          >
            Back to live streams
          </button>
        </div>
      </Layout>
    );
  }

  if (!stream) {
    return (
      <Layout>
        <div className="user-live-page">
          <p>Loading live stream...</p>
        </div>
      </Layout>
    );
  }

  // STEP 9: Main UI
  return (
    <Layout>
      <div className="user-live-page">
        <div className="user-live-container">
          <div className="user-live-header">
            <button
              className="live-icon-btn"
              onClick={() => navigate(-1)}
              aria-label="Go back"
              title="Go back"
            >
              <ArrowLeft size={23} />
            </button>

            <h3>Live Streaming</h3>

            <button
              className="live-icon-btn"
              onClick={handleShare}
              aria-label="Share live stream"
              title="Share live stream"
            >
              <Share2 size={23} />
            </button>

            {/* LEAVE STREAM BUTTON */}
            <button
              className="live-icon-btn"
              onClick={handleLeaveStream}
              aria-label="Leave live stream"
              title="Leave live stream"
            >
              <LogOut size={23} />
            </button>
          </div>

          <div className="live-player-card">
            {renderLiveContent()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserLiveStream;



